export default {
    person: 'persons/quicksearch/:query',
    property: 'properties/quicksearch/:query',
    project: 'projects/quicksearch/:query',
    demand: 'demands/quicksearch/:query',
    address: 'maps/address',
    location: 'maps/latlng',
    mapFullAddress: 'maps/full-address',
}